import { useEffect, useState } from 'react';
import { useGetUser, useAuthSelector } from '@echotex/api-react';
import { getSessionCookie } from '@core-web/lib';

interface IResponse {
  isLoading: boolean;
  isAuthenticated: boolean;
}

export const useVerifyUser = (): IResponse => {
  const [isPageLoading, setPageLoading] = useState<boolean>(true);
  const isAuthTokenAvailable = getSessionCookie('auth');
  const { callApi, error } = useGetUser();
  const { isAuthenticated } = useAuthSelector();

  useEffect(() => {
    if (isAuthTokenAvailable) {
      callApi(null);
    } else {
      setPageLoading(false);
    }
  }, [isAuthTokenAvailable]);

  useEffect(() => {
    if (error) {
      setPageLoading(false);
    }
  }, [error]);

  useEffect(() => {
    if (isAuthenticated) {
      setPageLoading(false);
    }
  }, [isAuthenticated]);

  return {
    isLoading: isPageLoading,
    isAuthenticated,
  };
};
